/**
 * This file contains the BlogitModal component, which allows users to post their notes as a blog entry.
 * The modal collects necessary information like category and an optional link, then saves the post
 * directly to the Firebase Realtime Database.
 */


import { Button, FormControl, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import LinearProgress from "@mui/material/LinearProgress";
import MenuItem from "@mui/material/MenuItem";
import Modal from "@mui/material/Modal";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import { push, ref, set } from "firebase/database";
import { useEffect, useState } from "react";
import { auth, database } from "../firebase.js";
import userName from "./useUsername.js";

export function BlogitModal({
  open,
  handleClose,
  title,
  content,
  contentHTML,
}) {
  const [feedback, setFeedBack] = useState("");
  const [category, setCategory] = useState("");
  const [link, setLink] = useState("");
  const [tag, setTag] = useState("");
  const user = auth.currentUser;

  const [formShow, setFormShow] = useState(true);
  const [progress, setProgress] = useState(false);

  const handleLink = (event) => {
    setLink(event.target.value);
  };

  const handleCategory = (event) => {
    setCategory(event.target.value);
  };

  function generateTag() {
    return Math.floor(10000 + Math.random() * 90000);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) {
      return alert("You must be logged in to post blogit");
    }
    const tag = await generateTag();
    if (!category) {
      alert("category cannot be empty");
      return;
    }
    setFormShow(false);
    setProgress(true);
    setFeedBack("compiling...");
    const postRef = ref(database, "blogit");
    const newPostRef = push(postRef);
    const username = await userName();

    await set(newPostRef, {
      title: title,
      content,
      contentHTML,
      uid: user?.uid,
      username: username,
      link: link,
      tag,
      category: category,
      createdAt: Date.now(),
    })
      .then(() => {
        setProgress(false);
        setFeedBack(
          "Your post has been saved successfully.To make changes and withraw your coins visit Clan Circle App."
        );

        setTag(tag);
      })
      .catch((error) => {
        if (error.response) {
          setFeedBack("error saving ");
        } else {
          setFeedBack("error occur");
        }
        setProgress(false);
        console.error("There was an error", error);
      });
  };

  useEffect(() => {
    if (!open) {
      setFormShow(true);
      setProgress(false);
      setFeedBack("");
      setLink("");
      setTag("");
      setCategory("");
    }
  }, [open]);

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <>
            <Typography
              variant="h5"
              component="div"
              sx={{
                display: "block",
                color: "text.secondary",
                textAlign: "center",
              }}
            >
              BlogIT
            </Typography>
            {formShow && (
              <FormControl>
                <Box
                  style={{
                    padding: "2rem",
                    margin: "2rem",
                    boxShadow: "1px 1px 2px 1px ",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <TextField
                    onChange={handleLink}
                    name="link"
                    value={link}
                    id="outlined-email-input"
                    label="link"
                    type="email"
                    variant="filled"
                    style={{ margin: "0.5rem", marginTop: "1rem" }}
                  />
                  <div>
                    <FormControl
                      variant="filled"
                      sx={{
                        margin: "0.5rem",
                        marginTop: "1rem",
                        minWidth: 120,
                      }}
                    >
                      <InputLabel id="demo-simple-select-filled-label">
                        category
                      </InputLabel>
                      <Select
                        required
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        value={category}
                        onChange={handleCategory}
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        <MenuItem value={"Technology"}>Technology</MenuItem>
                        <MenuItem value={"Business"}>Business</MenuItem>
                        <MenuItem value={"Education"}>Education</MenuItem>
                        <MenuItem value={"Entertainment"}>
                          Entertainment
                        </MenuItem>
                        <MenuItem value={"Food_and_Drink"}>
                          Food and Drink
                        </MenuItem>
                        <MenuItem value={"Finance"}>Finance</MenuItem>
                        <MenuItem value={"Marketing"}>Marketing</MenuItem>
                        <MenuItem value={"Science"}>Science</MenuItem>
                        <MenuItem value={"DIY_and _Crafts"}>
                          DIY and Crafts
                        </MenuItem>
                        <MenuItem value={"News_and_Opinion"}>
                          News and Opinion
                        </MenuItem>
                        <MenuItem value={"Parentin"}>Parenting</MenuItem>
                        <MenuItem value={"Photography"}>Photography</MenuItem>
                        <MenuItem value={"Technology_Review"}>
                          Technology Review
                        </MenuItem>
                        <MenuItem value={"Programming"}>Programming</MenuItem>
                        <MenuItem value={"Web_3"}>Web 3.0</MenuItem>
                        <MenuItem value={"Crypto"}>Crypto</MenuItem>
                        <MenuItem value={"Life_style"}>Life-style</MenuItem>
                        <MenuItem value={"Inspiration"}>Inspiration</MenuItem>
                        <MenuItem value={"Poem"}>Poem</MenuItem>
                        <MenuItem value={"Quote"}>Quote</MenuItem>
                        <MenuItem value={"Tech"}>Tech</MenuItem>
                        <MenuItem value={"Spiritual"}>Spiritual</MenuItem>
                        <MenuItem value={"Others"}>Others</MenuItem>
                      </Select>
                    </FormControl>
                  </div>

                  <Button
                    onClick={handleSubmit}
                    variant="outlined"
                    size="large"
                    style={{ margin: "0.5rem" }}
                  >
                    continue
                  </Button>
                </Box>
              </FormControl>
            )}
            <Typography id="modal-modal-title" variant="h6" component="h2">
              {progress && <LinearProgress />}
            </Typography>
            <Typography id="modal-modal-tag" sx={{ mt: 2, fontWeight: "bold" }}>
              {tag}
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2, fontStyle: "italic" }}
            >
              {feedback}
            </Typography>
          </>
        </Box>
      </Modal>
    </>
  );
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
};
